import React, { useEffect, useState } from 'react';
import CockpitManageApi from '@/fetch/bussiness/cockpitManage';
import { Table, Col, Row, Select, Button, Flex } from 'antd';
import { HttpStatusCode } from '@/fetch/core/constant';
import { vehicleBoardColumns } from '../../utils/columns';
import SelectVehicle from '../SelectVehicle';
import './index.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { clstagStr } from '@/utils/util';
import { CLSTAG } from '@/utils/constant';
const VehicleBoard = () => {
  const newCommon = useSelector((state: RootState) => state.newCommon);
  const { cockpitTeamNumber } = newCommon;
  const fetchApi = new CockpitManageApi();
  const [cockpitList, setCockpitList] = useState<any[]>([]);
  const [options, setOptions] = useState<any>({
    cockpitOptions: [],
    vehicleOptions: [],
  });
  const [bindVehicleModal, setBindVehicleModal] = useState<any>({
    isBindModalOpen: false,
    selectedVehicle: [],
    cockpitNumber: '',
  });
  const [searchForm, setSearchForm] = useState<{
    vehicleName: string | null;
    cockpitNumber: string | null;
  }>({
    vehicleName: null,
    cockpitNumber: null,
  });
  useEffect(() => {
    fetchCockpitListInfo(searchForm);
    fetchOptions();
  }, [cockpitTeamNumber]);

  const fetchCockpitListInfo = async (val: {
    vehicleName: string | null;
    cockpitNumber: string | null;
  }) => {
    const res = await fetchApi.getCockpitListInfo({
      ...val,
      cockpitTeamNumber: cockpitTeamNumber,
    });
    if (res.code === HttpStatusCode.Success) {
      setCockpitList(res.data);
    }
  };

  const fetchOptions = async () => {
    const res = await Promise.all([
      fetchApi.getVehicleList(cockpitTeamNumber),
      fetchApi.getCockpitListInfo({
        vehicleName: null,
        cockpitNumber: null,
        cockpitTeamNumber: cockpitTeamNumber,
      }),
    ]);
    if (
      res[0].code === HttpStatusCode.Success &&
      res[1].code === HttpStatusCode.Success
    ) {
      setOptions({
        vehicleOptions: res[0].data.map((item: any) => {
          return {
            label: item.name,
            value: item.code,
          };
        }),
        cockpitOptions: res[1].data.map((item: any) => {
          return {
            label: item.cockpitNumber,
            value: item.cockpitNumber,
          };
        }),
      });
    }
  };

  const handleSaveSearchVal = (
    val: any,
    type: 'vehicleName' | 'cockpitNumber'
  ) => {
    setSearchForm({
      ...searchForm,
      [type]: val,
    });
  };

  const handleReset = () => {
    setSearchForm({
      vehicleName: null,
      cockpitNumber: null,
    });
    fetchCockpitListInfo({
      vehicleName: null,
      cockpitNumber: null,
    });
  };

  const formatColumn = () => {
    return vehicleBoardColumns.map((column: any) => {
      switch (column.dataIndex) {
        case 'vehicleNameList':
          return {
            ...column,
            render: (text: any, record: any) => {
              return record.vehicleNameList.join(',');
            },
          };
        case 'operations':
          return {
            ...column,
            render: (text: any, record: any) => {
              return (
                <a
                  className="operate-btn"
                  onClick={() => {
                    setBindVehicleModal({
                      isBindModalOpen: true,
                      selectedVehicle: record.vehicleNameList,
                      cockpitNumber: record.cockpitNumber,
                    });
                  }}
                >
                  绑定管理
                </a>
              );
            },
          };
        default:
          return column;
      }
    });
  };
  return (
    <div className="bind-vehicle-container">
      <Flex className="bind-vehicle-search" justify="space-between">
        <Flex>
          <div className="search-select-container">
            <span>座席号</span>
            <Select
              options={options.cockpitOptions}
              placeholder={'请选择座席号'}
              showSearch={true}
              allowClear={true}
              filterOption={true}
              value={searchForm.cockpitNumber}
              onChange={(val) => handleSaveSearchVal(val, 'cockpitNumber')}
            />
          </div>
          <div className="search-select-container">
            <span>车牌号</span>
            <Select
              placeholder={'请选择车牌号'}
              options={options.vehicleOptions}
              showSearch={true}
              allowClear={true}
              filterOption={true}
              value={searchForm.vehicleName}
              onChange={(val) => handleSaveSearchVal(val, 'vehicleName')}
            />
          </div>
        </Flex>
        <div className="btn-container">
          <Button className="reset-btn" onClick={handleReset}>
            重置
          </Button>
          <Button
            type="primary"
            onClick={() => fetchCockpitListInfo(searchForm)}
            clstag={clstagStr(CLSTAG.BindVehicle_Search)}
          >
            查询
          </Button>
        </div>
      </Flex>

      <Table
        rowKey={'cockpitNumber'}
        dataSource={cockpitList}
        columns={formatColumn()}
        pagination={false}
        scroll={{
          y: 740,
        }}
      ></Table>

      {bindVehicleModal.isBindModalOpen && (
        <SelectVehicle
          {...bindVehicleModal}
          closeModal={() => {
            fetchCockpitListInfo(searchForm);
            setBindVehicleModal({
              isBindModalOpen: false,
              selectedVehicle: [],
              cockpitNumber: '',
            });
          }}
        />
      )}
    </div>
  );
};

export default React.memo(VehicleBoard);
